import React from 'react';
import { Select, Input, DatePicker } from 'antd';
import moment from 'moment';

const { Search } = Input;
const { RangePicker } = DatePicker;

const dateFormat = 'YYYY/MM/DD';
let d = new Date();

const DataFilters = ({ selectOptions, handleSelect, handleSearch }) => {
    return (
        <div className="d-flex flex-container">
            <Select style={{ width: 150 }} defaultValue="Type" onChange={handleSelect}>
                {selectOptions.map((option, index) => (
                    <Select.Option key={index} value={option.value}>
                        {option.label}
                    </Select.Option>
                ))}
            </Select>
            <RangePicker
                defaultValue={[moment(d, dateFormat), moment(d, dateFormat)]}
                format={dateFormat}
            />
            <Search
                placeholder=""
                onSearch={handleSearch}
                style={{ width: 200 }}
            />
        </div>
    );
}

DataFilters.defaultProps = {
    handleSearch: () => {},
    handleSelect: () => {},
    selectOptions: [{ label: 'Type', value: 'type' }]
};

export default DataFilters;